// src/components/FreePromoBanner.jsx
// Thin top-of-app banner shown while free-for-all promo is active.
// Dismissal is stored per configVersion, so a NEW promo re-shows the banner.
// Single set of base styles valid on both mobile and desktop (additive
// element — no cross-form-factor overrides needed).
import { useState } from 'react';
import { useSubscriptionConfig } from '../hooks/useSubscriptionConfig';
import { formatDate } from '../utils/dateUtils';

const DISMISS_KEY = 'promoBannerDismissedVersion';

const FreePromoBanner = () => {
  const config = useSubscriptionConfig();
  const [dismissedVersion, setDismissedVersion] = useState(
    () => localStorage.getItem(DISMISS_KEY)
  );

  if (!config.freeForAllActive) return null;
  const version = config.configVersion || 'default';
  if (dismissedVersion === version) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, version);
    setDismissedVersion(version);
  };

  return (
    <div
      role="status"
      // cyan-700/purple-700 (not -600): white small text needs >=4.5:1; the
      // -600 cyan end was 3.68:1. safe-area padding keeps the text clear of the
      // notch on the native Android build (env() resolves to 0 on the web, so
      // desktop/mobile-web are unchanged).
      className="w-full bg-gradient-to-r from-cyan-700 to-purple-700 text-white text-xs sm:text-sm px-10 py-2 text-center relative"
      style={{ paddingTop: 'calc(0.5rem + env(safe-area-inset-top, 0px))' }}
    >
      <span>
        🎉 All Pro features are currently FREE
        {config.freeModeEndsAt ? ` — until ${formatDate(config.freeModeEndsAt)}` : ''}!
      </span>
      <button
        onClick={dismiss}
        aria-label="Dismiss promo banner"
        // 44x44 min tap area (global CSS gives min-height on mobile; add width
        // so the target isn't a thin sliver), vertically centered on the row.
        className="absolute right-1 inset-y-0 grid place-items-center min-w-[44px] text-white/80 hover:text-white"
      >
        ✕
      </button>
    </div>
  );
};

export default FreePromoBanner;
